import React, {
  forwardRef,
  useEffect,
  useState,
  TextareaHTMLAttributes,
} from 'react';
import styles from './TextArea.module.scss';
import {useCustomPlaceholder} from '@/hooks/help/useCustomPlaceholder';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  error?: boolean;
  template?: string;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({value, onChange, error, placeholder, template, ...restProps}, ref) => {
    const [internalValue, setInternalValue] = useState(value);

    const {shouldShowCustomPlaceholder, actualPlaceholder} =
      useCustomPlaceholder({
        value: internalValue,
        template,
        placeholder,
      });

    useEffect(() => {
      if (value !== internalValue) {
        setInternalValue(value);
      }
    }, [value, internalValue]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setInternalValue(e.target.value);
      onChange?.(e);
    };

    return (
      <div className={`${styles.TextAreaContainer} ${error ? styles.ErrorBorder : ''}`}>
        <textarea
          ref={ref}
          value={internalValue}
          onChange={handleChange}
          placeholder={actualPlaceholder}
          className={styles.TextAreaWrapper}
          {...restProps}
        />
        {shouldShowCustomPlaceholder && (
          <div className={styles.CustomPlaceholder}>
            <div>{placeholder}</div>
          </div>
        )}
      </div>
    );
  },
);

TextArea.displayName = 'TextArea';

export default TextArea;
